import React from "react";
import config from "config";
import { Popover, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";

const CustomPopoverHoverBackground = styled(Typography).attrs()`
 .eui-option-inner{
  padding-top:12px ;
  padding-bottom:12px ;
 }
 .eui-option-inner:hover{
    background-color: ${(props) => props.theme.palette.light.c100};
},`;

const Exclusive = ({ currency = "INR", typeformParams = "" }) => {
  return (
    <div className="mr-60">
      {config.exclusive && (currency === "INR" || currency === "USD") && (
        <div>
          <Popover
            trigger="hover"
            onOverlayClick={() => {}}
            onVisibilityChange={function noRefCheck() {}}
            content={
              <CustomPopoverHoverBackground className="mb-0">
                {(currency === "INR" || currency === "USD") && (
                  <Popover.Options>
                    <a
                      href={
                        (currency === "INR"
                          ? "https://survey.typeform.com/to/TsIpGdvy"
                          : "https://survey.typeform.com/to/OEiogPi8") + typeformParams
                      }
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          {currency === "INR"
                            ? "Prepaid Bank Cards"
                            : "Physical/Prepaid Cards"}
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                          {currency === "INR"
                            ? "Bank cards for Channel Partners"
                            : "Send Money Instantly"}
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>
                )}
                {currency === "INR" && (
                  <Popover.Options>
                    <a
                      href={`https://survey.typeform.com/to/WhJc3aHN${typeformParams}`}
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          Direct Bank Payouts
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                          Instant Payments, Anytime
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>
                )}
                {currency === "INR" ? (
                  <>
                    <Popover.Options>
                      <a
                        href={`https://survey.typeform.com/to/GPwEC1Yw${typeformParams}`}
                        target="_blank"
                        className="d-flex justify-content-between"
                        rel="noreferrer"
                      >
                        <Typography component="span">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c300"
                            className="whitespace-nowrap text-left"
                          >
                            Employee Onboarding Kits
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c200"
                            className="mb-0 text-left"
                          >
                            Welcome new hires
                          </Typography.BodySmall>
                        </Typography>
                      </a>
                    </Popover.Options>
                    <Popover.Options>
                      <a
                        href={`https://survey.typeform.com/to/XM8sIjtH${typeformParams}`}
                        target="_blank"
                        className="d-flex justify-content-between"
                        rel="noreferrer"
                      >
                        <Typography component="span">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c300"
                            className="whitespace-nowrap text-left"
                          >
                            Long Service Awards
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c200"
                            className="mb-0 text-left"
                          >
                            Reward years of service
                          </Typography.BodySmall>
                        </Typography>
                      </a>
                    </Popover.Options>
                    <Popover.Options>
                      <a
                        href={`https://survey.typeform.com/to/qp3vxjHu${typeformParams}`}
                        target="_blank"
                        className="d-flex justify-content-between"
                        rel="noreferrer"
                      >
                        <Typography component="span">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c300"
                            className="whitespace-nowrap text-left"
                          >
                            Team Building
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c200"
                            className="mb-0 text-left"
                          >
                            Nurture Bonds Within Team
                          </Typography.BodySmall>
                        </Typography>
                      </a>
                    </Popover.Options>
                  </>
                ) : null}

                {currency === "USD" && (
                  <Popover.Options>
                    <a
                      href={`https://survey.typeform.com/to/UesBD6PF${typeformParams}`}
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          Swag
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                          Custom On-Demand Merchandise
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>
                )}
                {currency === "INR" && (
                  <Popover.Options>
                    <a
                      href={`https://survey.typeform.com/to/M8VxY7PC${typeformParams}`}
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          Cashback and Offers
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                          Exclusive Deals and Instant <br></br> Cashback
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>
                )}
                {currency === "INR" && (
                  <Popover.Options>
                    <a
                      href={`https://survey.typeform.com/to/CUPUQoST${typeformParams}`}
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          Corporate Mobility
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                         Travel risk management program
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>)}
              </CustomPopoverHoverBackground>
            }
            placement="bottom-end"
            offset={[100, 0]}
            width={312}
            className="popover-placement"
          >
            <Typography.LabelText
              id={`festive-reward-title`}
              className="cursor-pointer"
              color="dark"
              shade="c200"
              component="div"
            >
              Exclusive
              <Typography.BodySmall
                color="green"
                shade="c300"
                className="position-absolute ml-4"
                style={{ top: "7px" }}
                component="span"
              >
                New
              </Typography.BodySmall>
            </Typography.LabelText>
          </Popover>
        </div>
      )}
    </div>
  );
};

export default Exclusive;
